import { css } from '@betterment/samba-styled-system/css';

export const List: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ul className={css({ listStyleType: 'none', margin: '0', padding: '0' })}>{children}</ul>
);

List.displayName = 'Nav.List';
